import { useState } from 'react';

export default function AboutHero() {
  const [currentSlide] = useState(0);
  const totalSlides = 1;

  return (
    <section className="relative w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
                  src="/images/k2.png"
          alt="Fall River waterfront"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/40 via-primary-900/30 to-primary-900/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 lg:py-20">
        {/* Script text */}
        <p className="font-script text-white text-center text-lg md:text-xl lg:text-2xl mb-6 md:mb-8">
          America's One-Stop-Shop for Seafood
        </p>

        {/* Main content grid */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-8 max-w-7xl mx-auto">
          {/* Left: OUR COMPANY heading */}
          <div className="flex-1 text-center lg:text-left">
            <h1 className="font-heading text-white text-5xl md:text-6xl lg:text-7xl xl:text-8xl tracking-wide leading-tight">
                          OUR COMPANY
             
             
            </h1>
          </div>

          
          
        </div>

        {/* Bottom text */}
        <div className="max-w-5xl mx-auto mt-8 md:mt-12 text-center">
          <p className="font-heading text-white text-xl md:text-2xl lg:text-3xl tracking-wide leading-snug">
            Finest Kind Seafood LLC is a hands-on company built by people who learned the fish business from the ground up.
          </p>
        </div>
      </div>

      {/* Slide Navigation Arrows */}
      <button
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 text-white/60 hover:text-white transition-colors"
        aria-label="Previous"
      >
        <i className="ri-arrow-left-s-line text-3xl md:text-4xl" />
      </button>
      <button
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 text-white/60 hover:text-white transition-colors"
        aria-label="Next"
      >
        <i className="ri-arrow-right-s-line text-3xl md:text-4xl" />
      </button>

      {/* Slide indicators */}
      <nav className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {Array.from({ length: totalSlides }).map((_, i) => (
          <a
            key={i}
            href="#"
            className={`block w-2.5 h-2.5 rounded-full transition-colors ${
              i === currentSlide ? 'bg-white' : 'bg-white/40'
            }`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </nav>
    </section>
  );
}